/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckGeneralErrorCode } from './PaxCheckGeneralErrorCode';
import {
    PaxCheckGeneralErrorCodeFromJSON,
    PaxCheckGeneralErrorCodeFromJSONTyped,
    PaxCheckGeneralErrorCodeToJSON,
    PaxCheckGeneralErrorCodeToJSONTyped,
} from './PaxCheckGeneralErrorCode';

/**
 * 
 * @export
 * @interface PaxCheckGeneralError
 */
export interface PaxCheckGeneralError {
    /**
     * 
     * @type {PaxCheckGeneralErrorCode}
     * @memberof PaxCheckGeneralError
     */
    code: PaxCheckGeneralErrorCode;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckGeneralError
     */
    message?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PaxCheckGeneralError
     */
    details?: { [key: string]: string; } | null;
}



/**
 * Check if a given object implements the PaxCheckGeneralError interface.
 */
export function instanceOfPaxCheckGeneralError(value: object): value is PaxCheckGeneralError {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function PaxCheckGeneralErrorFromJSON(json: any): PaxCheckGeneralError {
    return PaxCheckGeneralErrorFromJSONTyped(json, false);
}

export function PaxCheckGeneralErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckGeneralError {
    if (json == null) {
        return json;
    }
    return {
        
        'code': PaxCheckGeneralErrorCodeFromJSON(json['code']),
        'message': json['message'] == null ? undefined : json['message'],
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function PaxCheckGeneralErrorToJSON(json: any): PaxCheckGeneralError {
    return PaxCheckGeneralErrorToJSONTyped(json, false);
}

export function PaxCheckGeneralErrorToJSONTyped(value?: PaxCheckGeneralError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': PaxCheckGeneralErrorCodeToJSON(value['code']),
        'message': value['message'],
        'details': value['details'],
    };
}

